import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'gf-pager-mini',
  template: require('./paging.mini.component.html')
})
export class PagerMiniComponent {
  @Input() showPageSize: boolean;
  @Input() pageSize: number;
  @Input() pageNum: number;
  @Input() items: any[];
  
  @Output() onpage: EventEmitter<any> = new EventEmitter<any>();
  
  hasNextPage: boolean;
  hasPreviousPage: boolean;

  constructor() { }

  ngOnInit(): void {
    this.setPageFlags();
  }

  ngOnChanges(): void {
    this.setPageFlags();
  }

  setPageSize(e: any, size: number): void {
    if (this.pageSize !== size) {
      this.onPageChange(size, 1);
    }
  }

  nextPage(): void {
    if (this.hasNextPage) {
      this.onPageChange(this.pageSize, this.pageNum + 1);
    }
  }

  previousPage(): void {
    if (this.hasPreviousPage) {
      this.onPageChange(this.pageSize, this.pageNum - 1);
    }
  }

  setPageFlags(): void {
    this.hasNextPage = _.size(this.items) === this.pageSize;
    this.hasPreviousPage = this.pageNum > 1;
  }

  onPageChange(size: number, num: number): void {
      const params = {
        pageSize: size,
        pageNum: num
      };
      this.onpage.emit(params);

    this.pageNum = num;
    this.pageSize = size;
    this.setPageFlags();
  }
}
